module.exports = __webpack_public_path__ + "img/tinkoff.5d2f4a90.svg";